// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Next__Image = require("../../reason/next/Next__Image.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var TMPUIKIT____ImgGallery = require("../../temporaryUIKit/TMPUIKIT____ImgGallery/TMPUIKIT____ImgGallery.bs.js");
var ConversationMessageImages_SingleImage_image_graphql = require("../../__generated__/ConversationMessageImages_SingleImage_image_graphql.bs.js");
var ConversationMessageImages_conversationMessage_graphql = require("../../__generated__/ConversationMessageImages_conversationMessage_graphql.bs.js");
var ConversationMessageImages_OneOfSeveralImages_image_graphql = require("../../__generated__/ConversationMessageImages_OneOfSeveralImages_image_graphql.bs.js");

function use(imageUrl) {
  var match = React.useState(function () {
        return false;
      });
  var setDoPreload = match[1];
  var timer = React.useRef(undefined);
  return {
          preloadElement: match[0] && imageUrl !== undefined ? JsxRuntime.jsx("link", {
                  as: "image",
                  href: imageUrl,
                  rel: "preload"
                }) : null,
          onMouseEnter: (function (param) {
              Core__Option.forEach(timer.current, (function (prim) {
                      clearTimeout(prim);
                    }));
              timer.current = Caml_option.some(setTimeout((function () {
                          setDoPreload(function (param) {
                                return true;
                              });
                        }), 100));
            }),
          onMouseLeave: (function (param) {
              Core__Option.forEach(timer.current, (function (prim) {
                      clearTimeout(prim);
                    }));
            })
        };
}

var PreloadImageOnHover = {
  use: use
};

var convertFragment = ConversationMessageImages_OneOfSeveralImages_image_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationMessageImages_OneOfSeveralImages_image_graphql.node, convertFragment, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationMessageImages_OneOfSeveralImages_image_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationMessageImages_OneOfSeveralImages_image_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationMessageImages_OneOfSeveralImages_image_graphql.node, convertFragment, fRef);
}

var ImageFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$1,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function Conversation__MessageImages$OneOfSeveralImages(props) {
  var onClick = props.onClick;
  var __size = props.size;
  var size = __size !== undefined ? __size : "small";
  var image = use$1(props.image);
  var match = use(props.preloadImageUrl);
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx("button", {
                      children: JsxRuntime.jsx(Next__Image.make, {
                            src: image.oneOfSeveralUrl,
                            width: 200,
                            height: 200,
                            unoptimized: true,
                            alt: "",
                            className: "w-full h-auto rounded object-cover transition-opacity duration-150 hover:opacity-80"
                          }),
                      className: size === "small" ? "col-span-2 row-span-2" : "col-span-3 row-span-3",
                      onClick: (function (param) {
                          onClick();
                        }),
                      onMouseEnter: match.onMouseEnter,
                      onMouseLeave: match.onMouseLeave
                    }),
                match.preloadElement
              ]
            });
}

var OneOfSeveralImages = {
  ImageFragment: ImageFragment,
  make: Conversation__MessageImages$OneOfSeveralImages
};

var convertFragment$1 = ConversationMessageImages_SingleImage_image_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationMessageImages_SingleImage_image_graphql.node, convertFragment$1, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationMessageImages_SingleImage_image_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationMessageImages_SingleImage_image_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(ConversationMessageImages_SingleImage_image_graphql.node, convertFragment$1, fRef);
}

var ImageFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$2,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function Conversation__MessageImages$SingleImage(props) {
  var onClick = props.onClick;
  var image = use$2(props.image);
  var match = use(props.preloadImageUrl);
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx("button", {
                      children: JsxRuntime.jsx("img", {
                            className: "w-full h-auto rounded object-cover transition-opacity duration-150 hover:opacity-80 ",
                            src: image.url
                          }),
                      className: "col-span-6",
                      onClick: (function (param) {
                          onClick();
                        }),
                      onMouseEnter: match.onMouseEnter,
                      onMouseLeave: match.onMouseLeave
                    }),
                match.preloadElement
              ]
            });
}

var SingleImage = {
  ImageFragment: ImageFragment$1,
  make: Conversation__MessageImages$SingleImage
};

var convertFragment$2 = ConversationMessageImages_conversationMessage_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationMessageImages_conversationMessage_graphql.node, convertFragment$2, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationMessageImages_conversationMessage_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationMessageImages_conversationMessage_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(ConversationMessageImages_conversationMessage_graphql.node, convertFragment$2, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$3,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function Conversation__MessageImages$ImageGrid(props) {
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: "max-w-md w-[60vw] grid grid-cols-6 gap-1"
            });
}

var ImageGrid = {
  make: Conversation__MessageImages$ImageGrid
};

function Conversation__MessageImages(props) {
  var match = use$3(props.message);
  var images = Core__Option.getOr(Core__Option.map(match.images, (function (param) {
              return Core__Array.filterMap(param.edges, (function (edge) {
                            return Core__Option.map(edge, (function (edge) {
                                          return edge.node;
                                        }));
                          }));
            })), []);
  var match$1 = React.useState(function () {
        return false;
      });
  var setIsFullscreenCarouselOpen = match$1[1];
  var imagesForCarousel = images.map(function (image) {
        return {
                fullscreen: image.carouselFullscreen,
                large: image.carouselLarge,
                small: image.carouselSmall,
                thumb: image.carouselThumb
              };
      });
  var match$2 = React.useState(function () {
        
      });
  var setSelectedImage = match$2[1];
  var onSelectImage = function (i) {
    setSelectedImage(function (param) {
          return i;
        });
    setIsFullscreenCarouselOpen(function (param) {
          return true;
        });
  };
  var len = images.length;
  var tmp;
  if (len !== 1) {
    if (len !== 0) {
      var numImages = images.length;
      if (numImages % 3 === 2) {
        var firstTwo = images.slice(0, 2);
        var rest = images.slice(2);
        tmp = JsxRuntime.jsxs(Conversation__MessageImages$ImageGrid, {
              children: [
                firstTwo.map(function (image, i) {
                      return JsxRuntime.jsx(Conversation__MessageImages$OneOfSeveralImages, {
                                  image: image.fragmentRefs,
                                  size: "large",
                                  onClick: (function () {
                                      onSelectImage(i);
                                    }),
                                  preloadImageUrl: image.carouselFullscreen
                                }, String(i));
                    }),
                rest.map(function (image, i) {
                      return JsxRuntime.jsx(Conversation__MessageImages$OneOfSeveralImages, {
                                  image: image.fragmentRefs,
                                  onClick: (function () {
                                      onSelectImage(i);
                                    }),
                                  preloadImageUrl: image.carouselFullscreen
                                }, String(i + 2 | 0));
                    })
              ]
            });
      } else {
        tmp = JsxRuntime.jsx(Conversation__MessageImages$ImageGrid, {
              children: images.map(function (image, i) {
                    return JsxRuntime.jsx(Conversation__MessageImages$OneOfSeveralImages, {
                                image: image.fragmentRefs,
                                onClick: (function () {
                                    onSelectImage(i);
                                  }),
                                preloadImageUrl: image.carouselFullscreen
                              }, String(i));
                  })
            });
      }
    } else {
      tmp = null;
    }
  } else {
    var image = images[0];
    tmp = JsxRuntime.jsx(Conversation__MessageImages$ImageGrid, {
          children: JsxRuntime.jsx(Conversation__MessageImages$SingleImage, {
                image: image.fragmentRefs,
                onClick: (function () {
                    onSelectImage(0);
                  }),
                preloadImageUrl: image.carouselFullscreen
              })
        });
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(TMPUIKIT____ImgGallery.CarouselDialog.make, {
                      isOpen: match$1[0],
                      onDismiss: (function () {
                          setIsFullscreenCarouselOpen(function (param) {
                                return false;
                              });
                        }),
                      children: JsxRuntime.jsx(TMPUIKIT____ImgGallery.Carousel.make, {
                            images: imagesForCarousel,
                            onSelect: (function (i) {
                                setSelectedImage(function (param) {
                                      return i;
                                    });
                              }),
                            selectedIndex: Core__Option.getOr(match$2[0], 0),
                            imgSize: "fullscreen"
                          })
                    }),
                tmp
              ]
            });
}

var Gallery;

var CarouselImg;

var make = Conversation__MessageImages;

exports.PreloadImageOnHover = PreloadImageOnHover;
exports.OneOfSeveralImages = OneOfSeveralImages;
exports.SingleImage = SingleImage;
exports.Fragment = Fragment;
exports.Gallery = Gallery;
exports.CarouselImg = CarouselImg;
exports.ImageGrid = ImageGrid;
exports.make = make;
/* react Not a pure module */
